import apiClient from '../apiClient';
import { DELETE_MASTER_REFERENCE_URL } from '../apiUrl';

const deleteMasterDataReferenceApi = (param, Id) => {
  return apiClient.delete(DELETE_MASTER_REFERENCE_URL(param, Id));
};

export default deleteMasterDataReferenceApi;
